import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "HelpCenterWidget" */ './HelpCenterHomeWidget'),
  modules: ['./HelpCenterHomeWidget'],
  loading: () => <div />
});

export default LoadableWidget;
